import { Monitor, Laptop, Tablet, Smartphone } from 'lucide-react';

export const getDeviceIcon = (type) => {
  const icons = { Desktop: Monitor, Laptop, Tablet, Phone: Smartphone };
  return icons[type] || Monitor;
};

export const getBlockerStatusBadge = (status) => {
  const styles = {
    'Active': 'bg-destructive/10 text-destructive border-destructive/50',
    'Client Notified': 'bg-warning/10 text-warning border-warning/50',
    'Client Confirmed': 'bg-blue-500/10 text-blue-400 border-blue-500/50',
    'Pending Manager Approval': 'bg-purple-500/10 text-purple-400 border-purple-500/50',
    'Pending L3 Verification': 'bg-orange-500/10 text-orange-400 border-orange-500/50',
    'Verified & Cleared': 'bg-success/10 text-success border-success/50',
    'Rejected': 'bg-destructive/10 text-destructive border-destructive/50',
  };
  return styles[status] || 'bg-zinc-500/10 text-zinc-400 border-zinc-500/50';
};

export const getLevelBadge = (level) => {
  if (level === 1) return 'bg-blue-500/10 text-blue-400 border-blue-500/50';
  if (level === 2) return 'bg-purple-500/10 text-purple-400 border-purple-500/50';
  return 'bg-red-500/10 text-red-400 border-red-500/50';
};

export const getStaleBadge = (level) => {
  if (level === 1) return 'bg-l1-stale/10 text-l1-stale';
  if (level === 2) return 'bg-l2-stale/10 text-l2-stale';
  return 'bg-l3-stale/10 text-l3-stale';
};

export const getStatusBadge = (status) => {
  const styles = {
    'In Progress': 'bg-primary/10 text-primary border-primary/50',
    'Blocked': 'bg-destructive/10 text-destructive border-destructive/50',
    'Completed': 'bg-success/10 text-success border-success/50',
  };
  return styles[status] || 'bg-zinc-500/10 text-zinc-400 border-zinc-500/50';
};
